exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.AlblumBox[data-v-7dfed496] {\n    width: 94%;\n    margin: 3%;\n}\n.AlblumBox .leftBox[data-v-7dfed496] {\n      width: calc( 94vw - 158px);\n}\n}\n", ""]);

